import { GET_FLAGS_ACTIVITY_SUCCESS } from "./actionTypes";

const initialState = {
  flagsActivity: null,
};

const viewFlagsActivityReducer = (state = initialState, { type, flagsActivity }) => {
  switch (type) {
    case GET_FLAGS_ACTIVITY_SUCCESS:
      return {
        ...state,
        flagsActivity,
      };
    default:
      return state;
  }
};

export default viewFlagsActivityReducer;
